<div class="notify shadow {{notification.type}}" (click)="dismiss()">
    <b>{{notification.header}}</b><br />
    {{notification.message}}
</div>